let schema = {
    className: "CampaignCategory",
    limit: 10,
    showExport: false,
    // showCreate: false,
    // showUpdate: false,
    // showDelete: false,
    // bypassAccess: true,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "image",
            type: "ParseFile",
            show: false
        },
        {
            columnName: "title",
            type: "string",
            style: {
                whiteSpace: "normal",
                minWidth: "250px"
            }
        },
        {
            columnName: "descriptions",
            type: "string",
            style: {
                whiteSpace: "normal",
                minWidth: "300px"
            }
        },
        {
            columnName: "status",
            type: "string"
        },
        {
            columnName: "campaignStartDate",
            columnLabel: "CAMPAIGN START DATE",
            type: "Date",
            format: "MMM D, YYYY hh:mm A"
        },
        {
            columnName: "campaignEndDate",
            columnLabel: "CAMPAIGN END DATE",
            type: "Date",
            format: "MMM D, YYYY hh:mm A"
        },
        {
            columnName: "earningPeriod",
            columnLabel: "EARNING PERIOD",
            type: "Pointer",
            targetClass: "VoucherEarningPeriod",
            displayColumn: "name",
            show: false
        },
        {
            columnName: "createdAt",
            type: "Date",
            format: "MM/DD/YYYY hh:mm:ss A"
        },
        {
            columnName: "updatedAt",
            type: "Date",
            format: "MM/DD/YYYY hh:mm:ss A"
        }
    ]
};

module.exports = schema;


// WEBPACK FOOTER //
// ./components/CampaignCategory/CampaignCategorySchema.js